import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Timer from './Timer.js';

const FormatoReservacionDay = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
}

const FormatoReservacionTime = {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false
}
const PhoneBoothTemporalizador = (props) => {
  const [room, setRoom] = useState([]);
  const [isCourtesy, setisCourtesy] = useState(true);
  const [start, setStart] = useState(false);
  const [isEnd, setIsEnd] = useState(false);
  const [reservacion, serReservaciones] = useState("");
  const [reservacionDate, setReservacionDate] = useState([]);

  const [fechaOriginal, setFechaOriginal] = useState(new Date());
  const [fechaFinal, setFechaFinal] = useState(null);

  const headerCheck = {
    "token_id": props.getTokenId(),
    "token_session": props.getTokenSession()
  }

  const headerSala = {
    "token_id": props.getTokenId(),
    "token_session": props.getTokenSession(),
    "room_id": "1"
  }

  const headerBook = {
    "token_id": props.getTokenId(),
    "token_session": props.getTokenSession(),
    "room_id": "361"
  }

  const headerBookCancel = {
    "token_id": props.getTokenId(),
    "token_session": props.getTokenSession(),
    "reservation_id": reservacion
  }

  const getInfoPhoneBooth = async () => {
    await axios
      .post("http://localhost/api/src/public" + '/phonebook/getSala', headerSala)
      .then((response) => {
        setRoom(response.data.data)
      })
      .catch((error) => {
        handleErrorIngresoCreate(error);
      });
  }

  const checkPhoneBookofDay = async () => {
    await axios
      .post("http://localhost/api/src/public" + '/phonebook/checkPhoneBookofDay', headerCheck)
      .then((response) => {
        if (response.data.success) {
          setReservacionDate(response.data.data);
          setisCourtesy(response.data.success);
          if (!parseInt(response.data.data.reservacion_isFinsih)) {
            setIsEnd(false)
            serReservaciones(response.data.data.reservacion_id)
          } else {
            setIsEnd(true)
          }
        } else {
          setisCourtesy(response.data.success);
          setIsEnd(false)
        }


      })
      .catch((error) => {
        handleErrorIngresoCreate(error);
      });
  }

  const bookPhoneBook = async () => {
    await axios
      .post("http://localhost/api/src/public" + '/phonebook/bookPhoneBook', headerBook)
      .then((response) => {
        setReservacionDate(response.data.data);
        setStart(true);
        setIsEnd(true)
      })
      .catch((error) => {
        handleErrorIngresoCreate(error);
      });
  }

  const cancelarbookPhoneBook = async () => {
    await axios
      .post("http://localhost/api/src/public" + '/phonebook/cancelPhoneBook', headerBookCancel)
      .then((response) => {
        setisCourtesy(false);
        checkPhoneBookofDay();
      })
      .catch((error) => {
        handleErrorIngresoCreate(error);
      });
  }

  const handleErrorIngresoCreate = (err) => {
    console.log(err.message);
  };

  useEffect(() => {
    getInfoPhoneBooth();
  }, []);

  useEffect(() => {
    checkPhoneBookofDay();
  }, [room]);


  return (
    <div className="strore_container_new_store">
      <div className="overlay_sala container_domicilio">
        <div id="content_sala" className="container_sala">
          <div className="container-fluid">
            <div className="content-resvations">
              <div className="container-resvations-title">
                {props.user && props.user.memberId ? (
                  <div className="container-room" style={{ "display": "flex", "justifyContent": "center", "alignItems": "center", "height": "100vh" }}>
                    {room ? (
                      <div className="container-room-header card-panel panel panel-default card card_room">
                        <div
                          className="panel-heading card-panel-heading col-md-6 col-sm-6"
                          style={{ backgroundImage: "url('" + room.imagen + "')" }}
                        ></div>
                        <div className="card-panel-body col-md-6 col-sm-6">
                          <div className="panel-body-description">
                            {room.descripcion ? (
                              <div className="panel-description-text">
                                {room.descripcion.slice(0, 150)}{room.descripcion.length > 150 ? '...' : null}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        {!isCourtesy ? (
                          <div className="panel-body-bottom">
                            <div className="panel-body form-group">
                              {start ?
                                (
                                  <div className="panel-body form-group">
                                    <button
                                      className="btn btn-block btn-primary  btn-singup btn_create"
                                      onClick={() => cancelarbookPhoneBook()}
                                      type="button"
                                    >
                                      Cancelar Reservacion
                                    </button>
                                    {reservacionDate ? (
                                      <div>
                                        <h4> Reservacion: {reservacionDate.reservacion_nombre}</h4>
                                        <h4> Hora de la Reservacion : {' '}
                                          {new Date(reservacionDate.reservacion_fecha_inicial).toLocaleString(undefined, FormatoReservacionDay)} : {' '}
                                          {new Date(reservacionDate.reservacion_fecha_inicial).toLocaleTimeString([], FormatoReservacionTime)} - {' '}
                                          {new Date(reservacionDate.reservacion_fecha_final).toLocaleTimeString([], FormatoReservacionTime)}
                                        </h4>
                                      </div>
                                    ) : null}
                                  </div>
                                ) : (
                                  <button
                                    className="btn btn-block btn-primary  btn-singup btn_create"
                                    onClick={() => bookPhoneBook()}
                                    type="button"
                                  >
                                    Reservar Sala
                                  </button>
                                )}
                            </div>
                          </div>
                        ) : (
                          isEnd ? (
                            <div className="panel-body-bottom">
                              <div className="panel-body form-group">
                                {reservacionDate ? (
                                  <div>
                                    <h4> Reservacion: {reservacionDate.reservacion_nombre}</h4>
                                    <h4> Hora de la Reservacion : {' '}
                                      {new Date(reservacionDate.reservacion_fecha_inicial).toLocaleString(undefined, FormatoReservacionDay)} : {' '}
                                      {new Date(reservacionDate.reservacion_fecha_inicial).toLocaleTimeString([], FormatoReservacionTime)} - {' '}
                                      {new Date(reservacionDate.reservacion_fecha_final).toLocaleTimeString([], FormatoReservacionTime)}
                                    </h4>
                                    <h4> Centro: {reservacionDate.reservacion_centro_name}</h4>
                                  </div>
                                ) : null}

                              </div>
                            </div>
                          ) : (
                            <div className="panel-body-bottom">
                              <div className="panel-body form-group">
                                <div>
                                  <button
                                    className="btn btn-block btn-primary  btn-singup btn_create"
                                    onClick={() => cancelarbookPhoneBook()}
                                    type="button"
                                  >
                                    Cancelar Reservacion
                                  </button>
                                </div>
                                <div>
                                  <h4> Reservacion: {reservacionDate.reservacion_nombre}</h4>
                                  <h4> Hora de la Reservacion : {' '}
                                    {new Date(reservacionDate.reservacion_fecha_inicial).toLocaleString(undefined, FormatoReservacionDay)} : {' '}
                                    {new Date(reservacionDate.reservacion_fecha_inicial).toLocaleTimeString([], FormatoReservacionTime)} - {' '}
                                    {new Date(reservacionDate.reservacion_fecha_final).toLocaleTimeString([], FormatoReservacionTime)}
                                  </h4>
                                  <h4> Centro: {reservacionDate.reservacion_centro_name}</h4>
                                </div>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    ) : null}
                  </div>
                ) : (
                  <div className="container-room container-room-PhoneBoo" style={{ "display": "flex", "justifyContent": "center", "alignItems": "center", "height": "100vh" }}>
                    <div className="container-room-header card-panel panel panel-default card card_room">
                      <h2 className="page-header">
                        Beneficio exlusivos para socios
                      </h2>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  )

};

export default PhoneBoothTemporalizador;



// WEBPACK FOOTER //
// ./src/PhoneBooth/PhoneBoothContainer.jsx